import { render, staticRenderFns } from "./hallofshame.vue?vue&type=template&id=03ffe666&scoped=true"
import script from "./hallofshame.vue?vue&type=script&lang=js"
export * from "./hallofshame.vue?vue&type=script&lang=js"
import style0 from "./hallofshame.vue?vue&type=style&index=0&id=03ffe666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffe666",
  null
  
)

export default component.exports